<template>
  <div class="mobile-floating-bar">
    <!-- 위: 프리미엄 라인 (롤링 배너) -->
    <div class="bar-top">
      <div class="bar-top-track">
        <span
          v-for="(item, i) in rollItems"
          :key="i"
          class="bar-top-item"
          :style="{ animationDelay: (i * rollStep) + 's', animationDuration: (rollItems.length * rollStep) + 's' }">
          {{ item }}
        </span>
      </div>
    </div>

    <!-- 아래: 전화 + 관심고객등록 -->
    <div class="bar-bottom">
      <a href="tel:010-4431-4422" class="bar-btn bar-phone">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
          <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.57.57a1 1 0 011 1v3.49a1 1 0 01-1 1C10.07 22 2 13.93 2 3.01a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.45.57 3.57a1 1 0 01-.24 1.01l-2.2 2.2z"/>
        </svg>
        <span class="phone-number">010.4431.4422</span>
      </a>
      <div class="bar-divider"></div>
      <button class="bar-btn bar-register" @click="openRegister">
        <span class="register-main">방문 예약하기</span>
        <span class="register-sub">계약 축하금 선착 지급중</span>
      </button>
    </div>
  </div>

  <!-- 관심고객등록 폼 -->
  <transition name="register-popup">
    <div v-if="showRegister" class="register-overlay" @click.self="closeRegister">
      <div class="register-modal register-fullform">
        <div class="register-header">
          <div class="register-title-wrap">
            <span class="register-title-en">PRIVATE RESERVATION</span>
            <h3 class="register-title">방문 예약 안내</h3>
          </div>
          <button class="register-close" @click="closeRegister">
            <span></span>
            <span></span>
          </button>
        </div>

        <div class="register-body" v-if="!isSubmitted">
          <div class="register-coupon-row">
            <p class="register-desc">
              <strong>르엘 리버파크 센텀</strong>은 철저한 예약제로<br/>
              운영됩니다. 초대 라인을 통해 안내드립니다.
            </p>
          </div>

          <form @submit.prevent="submitForm" class="register-form">
            <div class="form-group">
              <label class="form-label">이름 <span class="required">*</span></label>
              <input
                v-model="formData.name"
                type="text"
                class="form-input"
                placeholder="이름을 입력해주세요"
                required
              />
            </div>

            <div class="form-group">
              <label class="form-label">연락처 <span class="required">*</span></label>
              <div class="phone-inputs">
                <input
                  ref="phone1"
                  v-model="formData.phone1"
                  type="tel"
                  inputmode="numeric"
                  class="form-input phone-field"
                  placeholder="010"
                  maxlength="3"
                  required
                  @input="onPhoneInput('phone1', 3, 'phone2')"
                />
                <span class="phone-dash">-</span>
                <input
                  ref="phone2"
                  v-model="formData.phone2"
                  type="tel"
                  inputmode="numeric"
                  class="form-input phone-field"
                  placeholder="0000"
                  maxlength="4"
                  required
                  @input="onPhoneInput('phone2', 4, 'phone3')"
                />
                <span class="phone-dash">-</span>
                <input
                  ref="phone3"
                  v-model="formData.phone3"
                  type="tel"
                  inputmode="numeric"
                  class="form-input phone-field"
                  placeholder="0000"
                  maxlength="4"
                  required
                  @input="onPhoneInput('phone3', 4, null)"
                />
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">원하시는 상담시간 <span class="required">*</span></label>
              <div class="time-grid">
                <button type="button" class="time-btn" :class="{ active: formData.consultTime === opt }" v-for="opt in consultTimeOptions" :key="opt" @click="formData.consultTime = opt">{{ opt }}</button>
              </div>
            </div>

            <div class="form-group agreement">
              <div class="agreement-header">
                <label class="checkbox-label">
                  <input
                    v-model="formData.agree"
                    type="checkbox"
                    class="checkbox-input"
                    required
                  />
                  <span class="checkbox-custom"></span>
                  <span class="checkbox-text">개인정보 수집 및 이용 동의 <span class="required">*</span></span>
                </label>
                <button type="button" class="toggle-btn" @click="showPrivacy = !showPrivacy">
                  {{ showPrivacy ? '닫기' : '보기' }}
                </button>
              </div>
              <div class="privacy-content" :class="{ visible: showPrivacy }">
                <p>
                  <strong>1. 수집하는 개인정보 항목</strong><br />이름, 연락처
                </p>
                <p>
                  <strong>2. 수집 및 이용 목적</strong><br />분양 관련 상담 및 정보 제공
                </p>
                <p>
                  <strong>3. 보유 및 이용 기간</strong><br />수집일로부터 1년간 보관 후 파기
                </p>
              </div>
            </div>

            <button type="submit" class="submit-btn" :disabled="isSubmitting">
              <span v-if="!isSubmitting">상담신청하기</span>
              <span v-else>전송 중...</span>
            </button>
          </form>
        </div>

        <!-- 성공 -->
        <div v-else class="register-success">
          <div class="success-icon">✓</div>
          <h3>신청이 완료되었습니다</h3>
          <p>빠른 시일 내에 연락드리겠습니다.</p>
          <button @click="resetForm" class="reset-btn">닫기</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { registerCustomer } from '@/firebase/customerService'

export default {
  name: 'MobileFloatingBar',
  data() {
    return {
      showRegister: false,
      showPrivacy: false,
      isSubmitting: false,
      isSubmitted: false,
      formData: {
        name: '',
        phone1: '010',
        phone2: '',
        phone3: '',
        consultTime: '',
        agree: false
      },
      consultTimeOptions: ['오전', '오후', '18시 이후', '언제든지 가능'],
      rollStep: 3.6,
      rollItems: [
        '해운대 센텀 중심 입지',
        '신세계 백화점·벡스코 인접',
        '동해선 재송역 초역세권',
        '광안대교 광역 인프라',
        '반경 1km 초·중·고 학군',
        'APEC 나루공원 도보권',
        '수영강 광활한 리버뷰',
        '67층 랜드마크',
        '2,070세대 대단지',
        '롯데건설 하이엔드 르엘'
      ]
    }
  },
  beforeUnmount() {
    window.removeEventListener('open-register-popup', this.openRegister)
  },
  watch: {
    '$route.query.popup'(val) {
      if (val === '1') {
        this.$nextTick(() => {
          this.openRegister()
          this.$router.replace({ path: this.$route.path, query: {} })
        })
      }
    }
  },
  mounted() {
    window.addEventListener('open-register-popup', this.openRegister)
    if (this.$route.query.popup === '1') {
      this.$nextTick(() => {
        this.openRegister()
        this.$router.replace({ path: this.$route.path, query: {} })
      })
    }
  },
  methods: {
    openRegister() {
      this.showRegister = true
      document.body.style.overflow = 'hidden'
    },
    closeRegister() {
      this.showRegister = false
      document.body.style.overflow = ''
    },
    async submitForm() {
      if (!this.formData.consultTime) {
        alert('원하시는 상담시간을 선택해주세요.')
        return
      }
      if (!this.formData.agree) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }
      this.isSubmitting = true
      try {
        await registerCustomer({
          name: this.formData.name,
          phone: `${this.formData.phone1}${this.formData.phone2}${this.formData.phone3}`,
          consultTime: this.formData.consultTime,
          source: 'website'
        })
        this.isSubmitted = true

        // 네이버 전환 스크립트 - 신청완료(lead)
        if (window.wcs) {
          if (!window.wcs_add) window.wcs_add = {}
          window.wcs_add['wa'] = 's_5a3399ef72b5'
          var _conv = {}
          _conv.type = 'lead'
          window.wcs.trans(_conv)
        }
      } catch (error) {
        console.error('등록 오류:', error)
        alert('등록 중 오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSubmitting = false
      }
    },
    resetForm() {
      this.formData = {
        name: '',
        phone1: '010',
        phone2: '',
        phone3: '',
        consultTime: '',
        agree: false
      }
      this.isSubmitted = false
      this.showPrivacy = false
      this.closeRegister()
    },
    onPhoneInput(field, maxLen, nextRef) {
      this.formData[field] = this.formData[field].replace(/[^0-9]/g, '')
      if (this.formData[field].length >= maxLen && nextRef) {
        this.$refs[nextRef].focus()
      }
    }
  }
}
</script>

<style scoped>
.mobile-floating-bar {
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 900;
  flex-direction: column;
  box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.25);
}

/* 위: 프리미엄 롤링 배너 */
.bar-top {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  background:
    linear-gradient(180deg, #F4ECDC 0%, #EFE8DA 100%);
  border-top: 1px solid rgba(201, 169, 107, 0.55);
  overflow: hidden;
}
.bar-top::before {
  content: '';
  position: absolute;
  left: 0; right: 0; top: 0;
  height: 1px;
  background: linear-gradient(90deg,
    transparent 0%,
    rgba(201, 169, 107, 0.85) 50%,
    transparent 100%);
  pointer-events: none;
}

.bar-top-track {
  position: relative;
  height: 20px;
  width: 100%;
  max-width: 320px;
  overflow: hidden;
  -webkit-mask-image: linear-gradient(90deg,
    transparent 0%,
    #000 18%,
    #000 82%,
    transparent 100%);
          mask-image: linear-gradient(90deg,
    transparent 0%,
    #000 18%,
    #000 82%,
    transparent 100%);
}

.bar-top-item {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Paperlogy', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.025em;
  color: #1A1A1F;
  white-space: nowrap;
  opacity: 0;
  filter: blur(3px);
  transform: translateY(8px);
  animation: barTopRoll cubic-bezier(0.22, 0.61, 0.36, 1) infinite;
  text-shadow: 0 0 1px rgba(168, 136, 78, 0.08);
}

@keyframes barTopRoll {
  0%   { opacity: 0; transform: translateY(8px);  filter: blur(4px); }
  3%   { opacity: 1; transform: translateY(0);    filter: blur(0); }
  7%   { opacity: 1; transform: translateY(0);    filter: blur(0); }
  10%  { opacity: 0; transform: translateY(-8px); filter: blur(4px); }
  100% { opacity: 0; transform: translateY(-8px); filter: blur(4px); }
}

/* 아래: 전화 + 관심고객등록 */
.bar-bottom {
  display: flex;
  align-items: stretch;
  background: var(--le-noir, #0B0B0F);
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

.bar-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 12px;
  text-decoration: none;
  color: #fff;
  min-height: 48px;
  transition: background 0.2s ease;
}

.bar-btn:active {
  background: rgba(255, 255, 255, 0.1);
}

.bar-divider {
  width: 1px;
  background: rgba(255, 255, 255, 0.25);
  margin: 10px 0;
  flex-shrink: 0;
}

.phone-number {
  font-family: 'Paperlogy', system-ui, sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: var(--le-champagne, #C9A96B);
  letter-spacing: -0.04em;
}

.bar-phone svg {
  color: var(--le-champagne, #C9A96B);
}

.bar-register {
  font-family: var(--font-serif-kr, 'Noto Serif KR', serif);
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.02em;
  background: transparent;
  border: none;
  color: var(--le-pearl, #F4EFE6);
  flex-direction: column;
  gap: 4px;
  cursor: pointer;
}

.register-main {
  font-family: var(--font-serif-kr, 'Noto Serif KR', serif);
  font-size: 14px;
  font-weight: 500;
  color: var(--le-pearl, #F4EFE6);
  letter-spacing: 0.04em;
  animation: bounce1 3s ease-in-out infinite;
}

.register-sub {
  font-family: 'Paperlogy', var(--font-serif-kr, 'Noto Serif KR'), sans-serif;
  font-size: 10.5px;
  font-weight: 700;
  color: var(--le-champagne, #C9A96B);
  letter-spacing: -0.01em;
  animation: bounce2 3s ease-in-out infinite;
  animation-delay: 0.3s;
}

@keyframes bounce1 {
  0%, 100% { transform: translateY(0); }
  15% { transform: translateY(-6px); }
  30% { transform: translateY(0); }
}

@keyframes bounce2 {
  0%, 100% { transform: translateY(0); }
  15% { transform: translateY(-5px); }
  30% { transform: translateY(0); }
}

/* ===== 관심고객등록 팝업 ===== */
.register-overlay {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 2100;
  align-items: center;
  justify-content: center;
}

.register-modal {
  background: #fff;
  width: 100%;
  max-height: 90vh;
  border-radius: 20px 20px 0 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.register-modal.register-fullform {
  width: 92%;
  max-width: 400px;
  max-height: 85vh;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.register-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
}

.register-title-wrap {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.register-title-en {
  font-family: var(--font-mono-disp, 'Cinzel', serif);
  font-size: 9px;
  letter-spacing: 0.32em;
  font-weight: 500;
  color: var(--le-champagne-dark, #A8884E);
}

.register-title {
  font-family: var(--font-serif-kr, 'Noto Serif KR', serif);
  font-size: 17px;
  font-weight: 500;
  color: var(--le-noir, #0B0B0F);
  letter-spacing: 0.01em;
}

.register-close {
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  cursor: pointer;
  position: relative;
}

.register-close span {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 18px;
  height: 2px;
  background: #666;
}

.register-close span:first-child {
  transform: translate(-50%, -50%) rotate(45deg);
}

.register-close span:last-child {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.register-body {
  padding: 24px;
}

.register-coupon-row {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 24px;
}

.register-desc {
  font-family: var(--font-serif-kr, 'Noto Serif KR', serif);
  font-size: 13.5px;
  color: var(--le-graphite, #4A4751);
  line-height: 1.85;
  margin: 0;
  text-align: left;
  font-weight: 300;
}

.register-desc strong {
  font-family: var(--font-display, 'Italiana', serif);
  font-weight: 400;
  color: var(--le-noir, #0B0B0F);
  font-size: 16px;
  letter-spacing: 0.02em;
}

.register-coupon-row {
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(201, 169, 107, 0.25);
}

.register-form .form-group {
  margin-bottom: 20px;
}

.register-form .form-label {
  display: block;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.required {
  color: var(--primary, #004538);
}

.register-form .form-input {
  width: 100%;
  padding: 14px 16px;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 15px;
  color: #1a1a1a;
  outline: none;
  transition: border-color 0.2s ease;
}

.register-form .form-input:focus {
  border-color: var(--primary, #004538);
}

.register-form .form-input::placeholder {
  color: #bbb;
}

.visit-inputs {
  display: flex;
  gap: 8px;
}

.visit-field-wrap {
  flex: 1;
  position: relative;
}

.visit-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: #999;
  pointer-events: none;
  z-index: 1;
}

.visit-inputs .form-input {
  padding-left: 40px !important;
}

.visit-inputs select.form-input {
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23999' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
  padding-right: 36px;
  cursor: pointer;
}

.phone-inputs {
  display: flex;
  align-items: center;
  gap: 6px;
}

.phone-field {
  flex: 1;
  text-align: center;
}

.phone-dash {
  color: #999;
  font-size: 16px;
  flex-shrink: 0;
}

.time-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.time-btn {
  padding: 12px 10px;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 14px;
  font-weight: 500;
  color: #555;
  cursor: pointer;
  transition: all 0.2s ease;
}

.time-btn:hover { background: #f0f0f0; }

.time-btn.active {
  background: var(--primary, #004538);
  border-color: var(--primary, #004538);
  color: #fff;
  font-weight: 700;
}

/* 동의 */
.agreement {
  margin-bottom: 24px;
}

.agreement-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
}

.checkbox-input {
  display: none;
}

.checkbox-custom {
  width: 18px;
  height: 18px;
  border: 2px solid #ccc;
  border-radius: 4px;
  background: #fff;
  position: relative;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.checkbox-input:checked + .checkbox-custom {
  background: var(--primary, #004538);
  border-color: var(--primary, #004538);
}

.checkbox-input:checked + .checkbox-custom::after {
  content: '✓';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 11px;
}

.checkbox-text {
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 13px;
  color: #333;
}

.toggle-btn {
  background: none;
  border: none;
  font-size: 12px;
  color: #888;
  cursor: pointer;
  text-decoration: underline;
}

.privacy-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease;
  background: #f5f5f5;
  border-radius: 8px;
}

.privacy-content.visible {
  max-height: 200px;
  padding: 16px;
}

.privacy-content p {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 8px;
}

.privacy-content p:last-child {
  margin-bottom: 0;
}

.privacy-content strong {
  color: #333;
}

/* 제출 */
.submit-btn {
  width: 100%;
  padding: 18px;
  background: var(--le-noir, #0B0B0F);
  border: 1px solid var(--le-champagne, #C9A96B);
  border-radius: 0;
  font-family: var(--font-serif-kr, 'Noto Serif KR', serif);
  font-size: 15px;
  font-weight: 500;
  color: var(--le-pearl, #F4EFE6);
  cursor: pointer;
  letter-spacing: 0.06em;
  transition: all 0.3s ease;
  position: relative;
}

.submit-btn::after {
  content: '→';
  font-family: var(--font-serif-en, 'Cormorant Garamond', serif);
  color: var(--le-champagne, #C9A96B);
  margin-left: 10px;
  font-style: italic;
}

.submit-btn:active:not(:disabled) {
  background: var(--le-ink, #16161C);
}

.submit-btn:disabled {
  opacity: 0.6;
}

/* 성공 */
.register-success {
  padding: 48px 24px;
  text-align: center;
}

.success-icon {
  width: 60px;
  height: 60px;
  border: 2px solid var(--primary, #004538);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: var(--primary, #004538);
  margin: 0 auto 20px;
}

.register-success h3 {
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.register-success p {
  font-size: 14px;
  color: #888;
  margin-bottom: 28px;
}

.reset-btn {
  padding: 12px 40px;
  background: var(--primary, #004538);
  border: none;
  border-radius: 10px;
  font-family: var(--font-family, 'Noto Sans KR', sans-serif);
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
}

/* 팝업 애니메이션 */
.register-popup-enter-active {
  transition: opacity 0.3s ease;
}

.register-popup-enter-active .register-modal {
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.3s ease;
}

.register-popup-leave-active {
  transition: opacity 0.25s ease;
}

.register-popup-leave-active .register-modal {
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.register-popup-enter-from {
  opacity: 0;
}

.register-popup-enter-from .register-modal.register-fullform {
  transform: scale(0.9);
  opacity: 0;
}

.register-popup-leave-to {
  opacity: 0;
}

.register-popup-leave-to .register-modal.register-fullform {
  transform: scale(0.9);
  opacity: 0;
}

/* 모바일에서만 플로팅바 표시 */
@media (max-width: 768px) {
  .mobile-floating-bar {
    display: flex;
  }

}
</style>
